module.exports = __webpack_public_path__ + "img/Marci.c208ca2c.jpg";